import { Link } from "react-router"

interface ArticleListProps {
  articles: { label: string, url: string }[],
  label: string,
  right?: boolean,
  primary?: boolean
}

function ArticleList({ label, articles, right = true, primary = false }: ArticleListProps) {
  return <div>
    <h4 className={'font-semibold text-2xl mb-2 ' + (right ? 'text-right' : 'text-left')}>{label}</h4>
    {articles.map((item, index) => {
      return <Link
        to={item.url}
        key={index}
        className={'block rounded-lg px-3 py-1 mb-2 [line-break:anywhere] ' +
          (right ? 'text-right ' : 'text-left ') +
          (primary ? 'bg-primary text-white active:bg-darkPrimary' : 'bg-darkForeground ')
        }
        children={item.label}
      />
    })}
  </div>
}

export default ArticleList